import axios from './api';

export default {
  setGasoil(data) {
    return axios.put('/api/configuration/gasoil', data).then((res) => res.data);
  },
  getConfiguration() {
    return axios.get('/api/configuration').then((res) => res.data);
  },
};
